import { ReactComponent as archive } from './archive.svg';
import { ReactComponent as audio } from './audio.svg';
import { ReactComponent as document } from './document.svg';
import { ReactComponent as fallback } from './fallback.svg';
import { ReactComponent as presentation } from './presentation.svg';
import { ReactComponent as source } from './source.svg';
import { ReactComponent as spreadsheet } from './spreadsheet.svg';

export const fileIcons = {
  archive,
  audio,
  document,
  fallback,
  presentation,
  source,
  spreadsheet,
};
